import { Box } from "@mui/material";
import { sessionContainer } from "./styles";

const SessionContainer = ({ children }) => {
  return <Box sx={(theme) => sessionContainer(theme)}>{children}</Box>;
};

export default SessionContainer;
